import { render } from "./BarWithValue.vue?vue&type=template&id=761d8333&scoped=true"
import script from "./BarWithValue.vue?vue&type=script&lang=js"
export * from "./BarWithValue.vue?vue&type=script&lang=js"

import "./BarWithValue.vue?vue&type=style&index=0&id=761d8333&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761d8333"]])

export default __exports__